import { render, staticRenderFns } from "./assetStorageLocation.vue?vue&type=template&id=8242aa1e"
import script from "./assetStorageLocation.vue?vue&type=script&lang=js"
export * from "./assetStorageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports